import { createSelector } from 'reselect';
import { stateSelector } from '../stateSelector';

export const errorSelector = createSelector(
  stateSelector,
  state => state.error,
);
